/**
 * Common models used across the application
 */

/**
 * Paged request parameters
 */
export interface PagedRequest {
  pageNumber?: number;
  pageSize?: number;
  searchTerm?: string | null;
  sortBy?: string | null;
  sortDescending?: boolean;
}

/**
 * Paged response wrapper
 */
export interface PagedResponse<T> {
  items: T[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

/**
 * Generic API response wrapper
 */
export interface ApiResponse<T> {
  success: boolean;
  data?: T | null;
  message?: string | null;
  errors?: string[] | null;
}

/**
 * Error response from API
 */
export interface ErrorResponse {
  message: string;
  errorCode?: string | null;
  errors?: string[] | null;
  validationErrors?: Record<string, string[]> | null;
  traceId?: string | null;
  timestamp: string;
}

